function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: white;\n    width: 100%;\n    position: sticky;\n    border-bottom: 1px solid #ebebeb;\n    z-index: 1;\n    top: 0;\n    height: 51px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    overflow: hidden;\n    font-size: 0;\n    position: relative;\n    padding: 0;\n    user-select: none;\n\n    li {\n        display: inline-block;\n        height: 51px;\n        font-size: 16px;\n        text-align: center;\n        line-height: 51px;\n        color: #202834;\n        position: relative;\n        overflow: hidden;\n        cursor: pointer;\n\n        a {\n            display: inline-block;\n            height: 100%;\n            text-decoration: none;\n            margin-left: 20px;\n\n            &:link,\n            &:visited,\n            &:active {\n                color: #202834;\n            }\n\n            &.active {\n                color: #21467e;\n                border-bottom: 4px solid #21467e;\n            }\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
export var Container = styled.div(_templateObject());
export var Nav = styled.ul(_templateObject1());
